<template lang="pug">
  v-dialog(
    v-model="show",
    transition="slide-y-reverse-transition",
    persistent,
    max-width="500")
    v-card.pa-3
      v-card-text.text-xs-center
        v-layout(justify-center).mb-4
          span.title Выберете поля для открытия доступа
        v-layout(wrap justify-space-around)
          v-checkbox(
          v-for="item in fields",
          :label="item.fieldTitle",
          v-model="item.checked",
          :key="item.fieldName").mx-2
        Alert(:show="isAlert", :text="alertText")
      v-card-actions
        v-spacer
        v-btn(
          large,
          @click.prevent="cancel").mx-3 Отмена
        v-btn(
          large,
          color="primary",
          :loading="loading",
          :disabled="loading",
          @click.prevent="saveFilter").mx-3 Сохранить
        v-spacer
</template>

<script>
import Alert from '../Common/Alert/Alert'
export default {
  name: 'FilterFields',
  components: { Alert },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    }
  },
  created() {
    this.subscribeToMutations()
  },
  data: () => ({
    fields: [],
    isAlert: false,
    alertText: ''
  }),
  watch: {
    userFormFields(val, oldVal = []) {
      if (JSON.stringify(val) !== JSON.stringify(oldVal)) {
        this.fields = val
      }
    }
  },
  computed: {
    userFormFields() {
      return this.$store.state.db.userFormFields.fields
    },
    loading() {
      return this.$store.state.db.loading.postUserFormFields
    }
  },
  methods: {
    cancel() {
      this.$emit('close-filter-fields-dialog')
      this.isAlert = false
      this.alertText = ''
    },
    saveFilter() {
      this.$emit('save-user-fields', { fields: this.fields })
    },
    subscribeToMutations() {
      this.$store.subscribe((mutation, state) => {
        switch (mutation.type) {
          case 'POST_USER_FORM_FIELDS_SUCCESS':
            this.cancel()
            break
          case 'POST_USER_FORM_FIELDS_ERROR':
            this.isAlert = true
            this.alertText = state.db.errors.postUserFormFieldsError
            break
        }
      })
    }
  }
}
</script>

<style lang="sass" scoped>
.v-btn
  -webkit-border-radius: 4px
</style>



// WEBPACK FOOTER //
// src/components/DataBase/FilterFields.vue